import React, { useEffect, useState } from 'react';
import { BaseModal, Button, Input, ToastMessage } from '@cokitchen/cokitchen-components';
import { apiService } from 'services/base.service';
import { toast } from 'react-toastify';
import { ReactComponent as ChangeEmailIcon } from 'assets/icons/change-email-icon.svg';
import { UserProfileType } from 'models/user.model';

type Props = {
  show: boolean;
  onClose: () => void;
  refreshUser: () => void;
  user?: UserProfileType;
};

type ChangeEmailFormType = {
  email: string;
};
const ChangeEmailModal = ({ show, onClose, refreshUser, user }: Props) => {
  const [step, setStep] = useState(1);
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState<ChangeEmailFormType>({ email: user?.email || '' });
  const [timeLeft, setTimeLeft] = useState(30);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (timeLeft > 0) {
        setTimeLeft((prev) => prev - 1);
      }
    }, 1000);
    return () => clearTimeout(timer);
  }, [timeLeft]);

  const handleUpdate = async () => {
    const data = {
      email: form.email
    };
    try {
      setLoading(true);
      const res = await apiService.put(`user/change-email`, {
        data
      });
      if (res) {
        toast(<ToastMessage type='success' message='Email reset link sent ' />);
        refreshUser();
        setStep(2);
      }
    } catch (err: any) {
      toast(<ToastMessage type='error' message={err.response.data.message} />);
    } finally {
      setLoading(false);
    }
  };
  return (
    <BaseModal
      isOpen={show}
      title='Change Email'
      description={``}
      titleIconColor='danger'
      onRequestClose={() => onClose()}
      footer={
        <div>
          {step === 1 ? (
            <div className='flex justify-end gap-3'>
              <Button className='text-xs w-fit' color='primary' variant='outline' onClick={onClose}>
                Cancel
              </Button>
              <Button
                className='text-xs w-fit'
                color='primary'
                loading={loading}
                variant='block'
                onClick={handleUpdate}>
                Confirm
              </Button>
            </div>
          ) : (
            <Button
              className='text-xs w-full'
              color='primary'
              loading={loading}
              variant='block'
              onClick={onClose}>
              Continue
            </Button>
          )}
        </div>
      }>
      {step === 1 ? (
        <Input
          className='w-full'
          design='bordered'
          label={'Email'}
          name='email'
          placeholder={'johndoe@gmail.com'}
          value={form.email}
          onChange={(val) => setForm({ ...form, email: val.target.value })}
        />
      ) : (
        <div className='flex flex-col gap-4 justify-center items-center w-[40px] '>
          <ChangeEmailIcon />
          <div>
            <p className='font-bold text-[24px] text-center mb-[10px]'>Confirm new email</p>
            <p className='text-center text-sm'>
              A verification link has been sent to{' '}
              <span className='text-[#0080E5]'>{form.email}</span>. Please check your email and
              click the link to confirm
            </p>
          </div>
          <p className='text-sm'>
            Didn’t receive email?
            <span
              onClick={() => {
                if (timeLeft > 0) return;
                handleUpdate();
              }}
              className='text-[#3FB827]'>
              {' '}
              Resend {timeLeft > 0 && `in ${timeLeft} seconds`}
            </span>
          </p>
        </div>
      )}
    </BaseModal>
  );
};

export default ChangeEmailModal;
